import { Avatar, Checkbox, TableBody, TableCell } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router-dom'
import CustomHeading from '../../components/CustomHeading'
import CustomPagination from '../../components/CustomPagination'
import CustomSwitch from '../../components/CustomSwitch'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { NoDataFound } from '../../components/NoDataFound'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import User from '../../components/User'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { useCustomerType } from '../../hooks/CompanyConfiguration/useCustomerType'
import { useCustomer } from '../../hooks/Features/useCustomer'

import { formatDate, handleSelectAllClick, handleSelectedItem, isSelected, ROUTES } from '../../shared/constants'
import { itemsPerPage } from '../../shared/data'
import CustomFilterModal from '../../components/FilterArray/FilterArray'
import ImageDialog from '../../components/Dialog/ImageDialog'
import { SortIcon, FilterIcon } from '../../components/CustomComponents/CustomFilterIcon'

function Customers() {
  const { customers } = useContext(FeatureContext)
  const { customerTypes } = useContext(ConfigurationContext)
  const { getAllCustomer, deleteCustomer, deleteManyCustomer, BulkUpload, loading, updateCustomer, paginate, pdfCsvData, getPdfCsvData, downloadLoading } = useCustomer()
  const { getAllCustomerType } = useCustomerType()
  const [imageDialog, setImageDialog] = useState(false)
  const [image, setImage] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const history = useHistory()

  const [page, setPage] = React.useState(1)

  const [selected, setSelected] = React.useState([])
  const [deleteDialog, setDeleteDialog] = React.useState(false)

  const noOfPages = paginate && paginate.totalPage

  const handleChange = (event, value) => {
    setPage(value)
  }

  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const [uploadedfile, setUploadedFile] = React.useState('')
  const [open, setOpen] = React.useState(false)

  const [filterParams, setFilterParams] = useState({})

  useEffect(() => {
    getAllCustomer({ ...filterParams, page, searchQuery })
  }, [filterParams, page, searchQuery])

  useEffect(() => {
    getPdfCsvData()
  }, [])

  useEffect(() => {
    getAllCustomerType()
  }, [])

  const tempHeaders = [
    { label: 'name' },
    { label: 'customerTypeCode' },
    { label: 'designation' },
    { label: 'phoneNumber' },
    { label: 'email' },
    { label: 'state' },
    { label: 'city' },
    { label: 'pincode' },
    { label: 'residentAddress' },
    { label: 'siteAddress' },
    { label: 'gstNumber' },
    { label: 'assignEmployeeCode' },
  ]

  const bulkUpload = () => {
    const formData = new FormData()
    formData.append('file', uploadedfile)
    formData.append('sheetName', 'customer')
    BulkUpload(formData)
    // setOpenPopup(false)
    setUploadedFile('')
  }

  const handleSwicthChange = (item) => {
    updateCustomer({ ...item, active: !item.active, CustomerId: item._id })
  }

  const headingOnClick = {
    type: () => {
      setOpen(true)
    },
  }

  return (
    <Layout
      heading="Customer"
      url={ROUTES.ADD_CUSTOMER}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      // deleteData={}
      editUrl={`/edit-customer/${selected.length && selected[0]._id}`}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      // none
      // addnone
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      tempHeaders={tempHeaders}
      headers={pdfCsvData.headings}
      data={pdfCsvData.headingValues}
      tempHeaderData={[]}
      filename="customers"
      sampleName="sample_customers"
      bulkUpload={bulkUpload}
      uploadedfile={uploadedfile}
      setUploadedFile={setUploadedFile}
      downloadLoading={downloadLoading}
      showEdit
      permissionName="LEAD"
    >
      <CustomFilterModal
        open={open}
        setOpen={setOpen}
        data={customerTypes}
        fieldValue="_id"
        fieldName="name"
        handleFilter={(filterData) => setFilterParams({ ...filterParams, customerType: filterData })}
        filterParams={filterParams.customerType}
      />

      <CustomTable>
        {customers.length > 0 && (
          <CustomTableHeading
            filterIcons={{
              type: <FilterIcon onClick={headingOnClick['type']} value={filterParams.customerType} />,
            }}
            heading={[
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < customers.length}
                checked={customers.length > 0 && selected.length === customers.length}
                onClick={(event) => handleSelectAllClick(event, customers, setSelected)}
              />,
              'image',
              'name',
              'type',
              'email',
              'phone',
              'agent',
              'created date',
              'status',
              'info',
            ]}
          />
        )}
        <TableBody>
          {!loading &&
            customers.length > 0 &&
            customers.map((item, index) => {
              const isItemSelected = isSelected(item, selected)
              return (
                <CustomTableRow key={index}>
                  <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>
                  <TableCell
                    onClick={() => {
                      setImageDialog(true)
                      setImage(item.profilePicture)
                    }}
                  >
                    <Avatar src={item.profilePicture} style={{ cursor: 'pointer' }} />
                  </TableCell>
                  <TableCell>{`${item.salutation ? item.salutation : ''} ${item.name}`}</TableCell>
                  {/* <TableCell>{item.designation}</TableCell> */}
                  <TableCell>{item.customerType && item.customerType.name}</TableCell>
                  <TableCell>{item.email}</TableCell>
                  <TableCell>{`${item.countryCode??"+91 "} ${item.phoneNumber}`}</TableCell>
                  {/* <TableCell>{item.state}</TableCell> */}
                  {/* <TableCell>{item.gstNumber}</TableCell> */}
                  <TableCell>{item.addedBy && item.addedBy.firstName}</TableCell>
                  <TableCell>{formatDate(item.createdAt)}</TableCell>
                  <TableCell>
                    <CustomSwitch checked={item.active} handleChange={() => handleSwicthChange(item)} />
                  </TableCell>
                  <TableCell>
                    <AiOutlineInfoCircle
                      style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                      // onClick={}
                      onClick={() => history.push(`/view-customer/${item._id}`)}
                    />
                  </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      <ImageDialog open={image && imageDialog} handleClose={() => setImageDialog(false)} image={image} />

      <ConfirmDialog
        open={deleteDialog}
        handleClose={() => setDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteCustomer({ customerId: selected[0]._id }, setSelected)}
      />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        // name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManyCustomer({ customerId: multipleId }, setSelected)}
      />
      {!loading && customers.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
      {loading && <Loader />}
      {!loading && !customers.length && <NoDataFound />}
    </Layout>
  )
}

export default Customers
